import { Root, Content, Trigger } from '@radix-ui/react-collapsible';
import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import { content, forceMountedContent, trigger } from './collapsible.css';

export const CollapsibleContent = ({
  duration = 300,
  /** Keeps the content mounted while closed, so its state survives. */
  forceMount,
  children,
}: PropsWithChildren<{ duration?: number; forceMount?: true }>) => {
  return (
    <Content
      className={clsx(content, forceMount && forceMountedContent)}
      forceMount={forceMount}
      style={{
        animationDuration: `${duration}ms`,
      }}
    >
      {children}
    </Content>
  );
};

export const CollapsibleTrigger = ({
  className,
  ...props
}: React.ComponentPropsWithRef<typeof Trigger>) => (
  <Trigger className={clsx(trigger, className)} {...props} />
);

export { Root as Collapsible };
